const fontWeights = {
    400: 400,
    600: 600,
};

export default fontWeights;
